let common = {
    interfacePath: function () {
        let server = '/api';
        let serverTestUrl = ""; //石油测试服
        let orderAgreementTemplateId = '';// 订单协议id
        let qualityAgreementTemplateId = '';// 质量保证确认书id
        switch (location.hostname) {
            // 本地开发环境
            case '127.0.0.1':
                serverTestUrl = '//11.8.236.41/csapi';
                orderAgreementTemplateId = 'XY200527114189765';
                qualityAgreementTemplateId = 'XY200527114689765';
                break;
            // 本地开发环境
            case 'localhost':
                serverTestUrl = '//11.8.236.41/csapi';
                orderAgreementTemplateId = 'XY200527114189765';
                qualityAgreementTemplateId = 'XY200527114689765';
                break;
            // 本地开发环境
            case 'dev.chemicals.com':
                serverTestUrl = '//11.8.236.41/csapi';
                orderAgreementTemplateId = 'XY200527114189765';
                qualityAgreementTemplateId = 'XY200527114689765';
                break;
            default:
                serverTestUrl = '/csapi';
                orderAgreementTemplateId = 'XY200527114189765';
                qualityAgreementTemplateId = 'XY200527114689765';
        }
        return {
            serverTestUrl,
            server,
            orderAgreementTemplateId,
            qualityAgreementTemplateId
        }
    }()
};

export default common
